import { normalizeUiPack, UI_PACK_CLASSIC } from "@/lib/uiPack";

const STORAGE_KEY = "restaurant_erp_ui_pack";

export function rememberUiPack(value) {
  try {
    localStorage.setItem(STORAGE_KEY, normalizeUiPack(value));
  } catch {
    /* ignore */
  }
}

/** Last known pack for guest login styling (before auth). */
export function rememberedUiPack() {
  try {
    return normalizeUiPack(localStorage.getItem(STORAGE_KEY) || UI_PACK_CLASSIC);
  } catch {
    return UI_PACK_CLASSIC;
  }
}

export function clearRememberedUiPack() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
